import { SubtaskIcon } from "../icons";

function CardSubtaskStats({ 
  completed, 
  total,
  withIcon = false,
}) {
  if (total === 0) {
    return null;
  }

  if (withIcon) {
    return (
      <div className="d-flex align-items-center">
        <SubtaskIcon color="#727580" height={12} width={16} className={'me-1'}/>
        <span>
          { completed } / { total }
        </span>
      </div>
    );
  }

  return (
    <>
      {completed} / {total}
    </>
  );
}

export { CardSubtaskStats };